import "./Sidebar.css";
import "./AwardsRail.css";

// AwardsRail: a small thumb tab fixed to the right edge of the screen.
// Visible only when the Special Awards drawer is closed.
function AwardsRail({ onOpen }) {
  return (
    <div
      className="ossdf-awards-rail"
      onClick={onOpen}
      role="button"
      title="Open Special Awards"
      aria-label="Open Special Awards"
    >
      <span className="ossdf-awards-rail-arrow">‹</span>
      <span className="ossdf-awards-rail-label">Special Awards</span>
    </div>
  );
}

export default AwardsRail;